export const UserCardTestIds = {
  unreadMessageCount: 'unread_message_count',
  mention: 'mention_notification'
} as const;
